import {
  fetchGraphQL,
} from '../Connections';

import {
  getFieldListString
} from './util';

export function queryAdminApplyPayment(variables) {
  const query = `mutation adminApplyPayment(
    $invoice_id: String!,
    $payment: PaymentInput!,
    $allocation: PaymentAllocationEnum!,
    $entries: [EntryInput],
    $application_date: String
    $overpayment_credit: OverpaymentCreditInput
  ) {
    adminApplyPayment(
      invoice_id: $invoice_id,
      payment: $payment,
      allocation: $allocation,
      entries: $entries,
      application_date: $application_date
      overpayment_credit: $overpayment_credit
    )
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryRefundPayment(variables, fields) {
  const query = `
    mutation refundPayment(
      $invoice_id: String!,
      $refund: LineItemRefundInput!
    ) {
      refundPayment(
        invoice_id: $invoice_id,
        refund: $refund
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryReversePayment(variables, fields) {
  const query = `
    mutation reversePayment(
      $payment_id: String!,
      $application_date: String,
      $reversal_type: ReversalTypeEnum!,
    ) {
      reversePayment(
        payment_id: $payment_id,
        application_date: $application_date,
        reversal_type: $reversal_type,
      ) {
        invoice {
          ${getFieldListString(fields)}
        },
        overpayment_credit {
          id
          readable_id
        }
        credit_reversed
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryListPayments(variables, fields) {
  const  query = `
    query listPayments(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order],
      $special: Special,
    ) {
      listPayments(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders,
        special: $special,
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryListReversals(variables, fields) {
  const  query = `
    query listReversals(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order],
    ) {
      listReversals(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders,
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryUpdatePayment(variables, fields) {
  const query = `mutation updatePayment(
    $payment_id: String!,
    $notes: String
  ) {
    updatePayment(
      payment_id: $payment_id,
      notes: $notes
    ) {
      ${getFieldListString(fields)}
    }
  }`;
  return fetchGraphQL({query, variables});
}